import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px'
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px'
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex justify-between items-center" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider" data-id="element-13">
              HEALTH & BEAUTY
            </span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
              </svg>
            </div>
            <span className="text-sm" data-id="element-21">Trending in the US</span>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-22">
        <div className="container mx-auto px-4 py-3" data-id="element-23">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-24">
            HEALTH & BEAUTY | Advertorial
          </p>
        </div>
      </header>

      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-25">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-26">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-27" />
          <p className="font-bold text-sm sm:text-base" data-id="element-28">
            UPDATE: Glisera™ Copper Renewal Serum Is Selling Out FAST! Grab
            Yours NOW to get 40% OFF + Fast FREE Shipping Across the US
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-29">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-30">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-31">
            <div className="py-6 px-0 md:px-4" data-id="element-32">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-33">
                {userCity} Dermatologists Reveal: Why Your $200 Retinol Serum
                Isn't Working (It's Not What You Think)
              </h1>

              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-34">
                After 35, your skin destroys collagen 3X faster than it builds
                it. Here's the 50-year-old solution that finally fixes both
                sides of the equation.
              </p>

              {/* Author and Date */}
              <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6" data-id="element-35">
                <div className="flex items-center" data-id="element-36">
                  <p className="text-sm text-gray-700" data-id="element-37">
                    By Sarah Mitchell, Health & Beauty | April 23, 2025
                  </p>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-38">
                  <EyeIcon size={16} className="mr-1" data-id="element-39" />
                  <span data-id="element-40">127,483</span>
                </div>
              </div>

              {/* Featured Hero Image */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/wxnURNDPvvypgVicyqFMKH/ChatGPT_Image_17_Δεκ_2025,_11_13_46_μ.μ..png" alt="Woman in her 40s admiring her smooth, healthy skin in natural light - confident and radiant after using Glisera Copper Renewal Serum" className="w-full h-auto" data-id="element-42" />
              </div>

              {/* Opening Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-43">
                <p className="mb-4" data-id="element-44">
                  If you're like most women over 35, you've spent hundreds—maybe
                  thousands—on anti-aging serums that promised to "boost
                  collagen" and "reduce fine lines."
                </p>
                <p className="mb-4" data-id="element-45">
                  And yet, when you look in the mirror, you still see those same
                  wrinkles staring back at you. Maybe they're even deeper than
                  before.
                </p>
                <p className="mb-4" data-id="element-46">
                  You've been diligent. You've layered on the retinol every
                  night. You've tried vitamin C in the morning. You've invested
                  in expensive peptide serums with names you can barely
                  pronounce.
                </p>
                <p className="mb-4" data-id="element-47">But nothing seems to stick.</p>
                <p className="mb-4" data-id="element-48">
                  Here's what's worse: you might have blamed yourself. Maybe you
                  thought you started too late. Or that you needed to spend even
                  more money on luxury brands. Or that aging skin was just
                  inevitable.
                </p>
                <p className="mb-4" data-id="element-49">
                  But according to leading dermatologists in {userCity}, there's
                  a reason why nothing has worked—and it's not your fault.
                </p>
              </div>

              {/* The Hidden Math Problem Section */}
              <div className="mb-10" data-id="element-50">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-51">
                  The Hidden Math Problem Your Skin Has Been Fighting
                </h2>
                <p className="mb-4" data-id="element-52">
                  Dr. Elena Rodriguez, a board-certified dermatologist with over
                  20 years of experience treating aging skin, puts it bluntly:
                </p>
                <p className="mb-4 text-lg font-semibold italic text-gray-700" data-id="element-53">
                  "Most women are trying to fill a bucket with holes in it."
                </p>
                <p className="mb-4" data-id="element-54">Here's what she means.</p>
                <p className="mb-4" data-id="element-55">
                  After 35, something shifts in your skin. Your body starts
                  producing enzymes called matrix metalloproteinases—or MMPs for
                  short. These enzymes have one job: to break down collagen and
                  elastin in your skin.
                </p>
                <p className="mb-4" data-id="element-56">
                  When you're younger, this process is balanced. Your skin
                  builds collagen at roughly the same rate it breaks it down.
                  Everything stays firm, smooth, and plump.
                </p>
                <p className="mb-4" data-id="element-57">But after 35, the balance tips.</p>

                {/* Problem Visualization Image */}
                <div className="mb-6 rounded-lg overflow-hidden bg-gray-50 p-4" data-id="element-58">
                  <img src="https://cdn.magicpatterns.com/uploads/3BmVzqZhhtusxr56crLxrS/ChatGPT_Image_17_Δεκ_2025,_11_13_41_μ.μ..png" alt="Medical illustration comparing skin before and after age 35 - showing balanced collagen production versus accelerated collagen breakdown by MMPs" className="w-full h-auto" data-id="element-59" />
                </div>

                <p className="mb-4" data-id="element-60">
                  Your skin shifts into breakdown mode. For every bit of
                  collagen your expensive serum helps create, those MMPs are
                  destroying two or three times as much.
                </p>
                <p className="mb-4" data-id="element-61">
                  It's like pouring water into a bucket with holes in the
                  bottom. No matter how much you pour in, it drains out faster
                  than you can fill it.
                </p>
                <p className="mb-4" data-id="element-62">
                  This is the hidden reason why that $200 retinol serum didn't
                  deliver the results you expected. It was only addressing half
                  the problem.
                </p>
                <p className="mb-4" data-id="element-63">
                  It was helping you build more collagen. But it wasn't doing
                  anything to stop the destruction.
                </p>
              </div>

              {/* What If Section */}
              <div className="mb-10" data-id="element-64">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-65">
                  What If You Could Fix Both Sides of the Equation?
                </h2>
                <p className="mb-4" data-id="element-66">
                  What if there was a way to plug the holes AND fill the bucket
                  at the same time?
                </p>
                <p className="mb-4" data-id="element-67">
                  That's exactly what a specific copper peptide called GHK-Cu
                  does—and it's the only ingredient that works on both sides of
                  this equation.
                </p>
                <p className="mb-4" data-id="element-68">
                  But here's where this story gets interesting.
                </p>
                <p className="mb-4" data-id="element-69">
                  GHK-Cu isn't new. In fact, it's been hiding in plain sight for
                  over 50 years.
                </p>
              </div>

              {/* 1973 Discovery Section */}
              <div className="mb-10" data-id="element-70">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-71">
                  The 1973 Discovery That Big Beauty Didn't Want You to Know
                  About
                </h2>
                <p className="mb-4" data-id="element-72">
                  In 1973, biochemist Dr. Loren Pickart made a remarkable
                  discovery while studying human blood plasma at the University
                  of California.
                </p>
                <p className="mb-4" data-id="element-73">
                  He found that young blood contained a mysterious factor that
                  made old liver cells behave like young cells again.
                </p>
                <p className="mb-4" data-id="element-74">
                  That factor was GHK-Cu—a tiny copper peptide that your body
                  produces naturally.
                </p>
                <p className="mb-4" data-id="element-75">
                  In early studies, the results were stunning. GHK-Cu didn't
                  just slow down aging in the lab. It actually reversed damage.
                  It accelerated wound healing. It rebuilt tissue that
                  researchers thought was beyond repair.
                </p>
                <p className="mb-4" data-id="element-76">
                  For decades, GHK-Cu was used quietly in burn clinics and wound
                  healing centers because of its remarkable ability to
                  regenerate skin tissue.
                </p>
                <p className="mb-4" data-id="element-77">
                  Surgeons used it. Wound care specialists relied on it. Medical
                  researchers published study after study showing its effects.
                </p>
                <p className="mb-4" data-id="element-78">But you probably never heard about it.</p>
                <p className="mb-4" data-id="element-79">Why?</p>
                <p className="mb-4" data-id="element-80">
                  Because GHK-Cu is a naturally occurring molecule. It couldn't
                  be easily patented. So while pharmaceutical companies focused
                  on synthetic alternatives they could own and market
                  aggressively, this powerful peptide remained largely in
                  medical settings.
                </p>
                <p className="mb-4" data-id="element-81">
                  It wasn't that GHK-Cu didn't work. It's that it wasn't as
                  profitable to promote.
                </p>
                <p className="mb-4" data-id="element-82">
                  Now, 50 years later, with mounting clinical evidence and
                  growing consumer demand, dermatologists are finally
                  recommending it to their patients.
                </p>
                <p className="mb-4" data-id="element-83">
                  And women in {userCity} are already seeing the difference.
                </p>
              </div>

              {/* How GHK-Cu Fixes Section */}
              <div className="mb-10" data-id="element-84">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-85">
                  How GHK-Cu Fixes What Retinol Can't
                </h2>
                <p className="mb-4" data-id="element-86">
                  Here's where GHK-Cu becomes truly remarkable. It works on both
                  sides of the aging equation in a way that no other ingredient
                  does.
                </p>

                {/* GHK-Cu Mechanism Image */}
                <div className="mb-6 rounded-lg overflow-hidden bg-gray-50 p-4" data-id="element-87">
                  <img src="https://cdn.magicpatterns.com/uploads/8mNx6LNBDp2mvbFRYpsNhS/ChatGPT_Image_17_Δεκ_2025,_11_13_40_μ.μ..png" alt="Infographic showing how GHK-Cu works on skin - plugs the holes by reducing collagen breakdown and fills the bucket by activating fibroblasts to produce collagen" className="w-full h-auto" data-id="element-88" />
                </div>

                <p className="mb-4 font-semibold" data-id="element-89">First, it plugs the holes.</p>
                <p className="mb-4" data-id="element-90">
                  GHK-Cu signals your skin to reduce the production of those
                  collagen-destroying enzymes we talked about earlier. Think of
                  it as turning down the drain—less collagen escapes.
                </p>
                <p className="mb-4 font-semibold" data-id="element-91">
                  Second, it fills the bucket.
                </p>
                <p className="mb-4" data-id="element-92">
                  At the same time, GHK-Cu activates your fibroblasts. These are
                  the cells in your skin responsible for building new collagen,
                  elastin, and hyaluronic acid.
                </p>
                <p className="mb-4" data-id="element-93">
                  When your fibroblasts are "asleep" or sluggish (which happens
                  as you age), they stop doing their job. GHK-Cu essentially
                  wakes them up and reminds them what they're supposed to be
                  doing.
                </p>
                <p className="mb-4" data-id="element-94">
                  Now you're producing more collagen AND keeping more of what
                  you produce.
                </p>
                <p className="mb-4" data-id="element-95">This changes everything.</p>
              </div>

              {/* Why This Works Section */}
              <div className="mb-10" data-id="element-96">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-97">
                  Why This Works When Retinol Didn't
                </h2>
                <p className="mb-4" data-id="element-98">
                  If you've tried retinol before, you know the experience. The
                  redness. The peeling. The "retinol uglies" phase where your
                  skin looks worse before it gets better.
                </p>
                <p className="mb-4" data-id="element-99">
                  Some women push through and see results. But studies show that
                  up to 40% of women stop using retinoids because of irritation.
                </p>
                <p className="mb-4" data-id="element-100">
                  If that's you, here's what you need to know.
                </p>
                <p className="mb-4" data-id="element-101">
                  Retinol works by forcing your skin to build collagen through
                  controlled inflammation. It literally irritates your skin on
                  purpose to trigger a healing response.
                </p>
                <p className="mb-4" data-id="element-102">
                  For some people, this works. But for many—especially those
                  with sensitive skin, rosacea, or barrier damage—it's too
                  harsh.
                </p>
                <p className="mb-4" data-id="element-103">GHK-Cu is different.</p>
                <p className="mb-4" data-id="element-104">
                  Instead of working through inflammation, it's naturally
                  anti-inflammatory. It soothes your skin while it works.
                </p>
                <p className="mb-4" data-id="element-105">
                  You can use it morning and night, under makeup, without
                  photosensitivity. You don't need to "ease in" or wait for your
                  skin to adjust.
                </p>
                <p className="mb-4" data-id="element-106">
                  Even women with rosacea, eczema, or compromised skin barriers
                  report that GHK-Cu calms rather than irritates.
                </p>
                <p className="mb-4 italic text-gray-700" data-id="element-107">
                  "I was terrified to try another active ingredient after my
                  retinol disaster," says Jennifer K., 47, from {userCity}. "But
                  GHK-Cu is different. My skin is calmer, smoother, and I'm
                  finally seeing the results I wanted without the redness and
                  peeling."
                </p>
              </div>

              {/* The Results Section */}
              <div className="mb-10" data-id="element-108">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-109">
                  The Results Women Are Seeing
                </h2>
                <p className="mb-4" data-id="element-110">
                  In clinical studies, participants using GHK-Cu saw
                  improvements in skin thickness and reduction in wrinkles
                  within 8-12 weeks.
                </p>
                <p className="mb-4" data-id="element-111">
                  But what does that look like in real life?
                </p>

                {/* Before/After Comparison Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-112">
                  <img src="https://cdn.magicpatterns.com/uploads/cwDfTTxTxRVLh1CyvR2Wsu/ChatGPT_Image_17_Δεκ_2025,_11_13_33_μ.μ..png" alt="Before and after comparison showing visible reduction in fine lines and wrinkles around the eyes after 12 weeks of using Glisera Copper Renewal Serum" className="w-full h-auto" data-id="element-113" />
                </div>

                <div className="space-y-6 mb-6" data-id="element-114">
                  <TestimonialCard quote="I honestly didn't expect much. After 15 years of trying every serum on the market, I was pretty cynical. But my skin quality, texture, and overall glow changed faster than with any retinoid or vitamin C I've used. People keep asking if I've had work done." author="Michelle R." age="43" imageUrl="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop" data-id="element-115" />
                  <TestimonialCard quote="I have extremely dry, sensitive skin. Most actives make me red and flaky within days. GHK-Cu didn't irritate at all—it actually reduced my redness and evened out my skin tone. By week 6, I was seeing real firmness around my jawline." author="Amanda L." age="51" imageUrl="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop" data-id="element-116" />
                  <TestimonialCard quote="After about 3 weeks, I noticed my skin looked more plump and hydrated. By week 8, my husband asked if I'd done something different. My fine lines around my eyes were visibly softer, and my skin just looked healthier." author="Karen D." age="39" imageUrl="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop" data-id="element-117" />
                </div>
              </div>

              {/* Introducing Glisera Section */}
              <div className="mb-10" data-id="element-118">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-119">
                  Introducing Glisera™ Copper Renewal Serum
                </h2>

                {/* Product Lifestyle Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-120">
                  <img src="https://cdn.magicpatterns.com/uploads/1BBJnYg2h6esjWBr8SvR56/ChatGPT_Image_17_Δεκ_2025,_11_13_37_μ.μ..png" alt="Glisera Copper Renewal Serum bottle on elegant marble surface with rose petals - premium skincare product photography" className="w-full h-auto" data-id="element-121" />
                </div>

                <p className="mb-4" data-id="element-122">
                  After months of research, we found one copper peptide serum
                  that checks every box: clinical-grade concentration,
                  bioavailable formulation, and most importantly—it actually
                  works.
                </p>
                <p className="mb-4" data-id="element-123">
                  Glisera™ Copper Renewal Serum was created by board-certified
                  dermatologists specifically for women 35-55 dealing with
                  stubborn aging signs that traditional serums haven't solved.
                </p>
                <p className="mb-4" data-id="element-124">Here's what makes Glisera™ different:</p>
                <div className="space-y-4 mb-6" data-id="element-125">
                  <div className="flex items-start" data-id="element-126">
                    <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-127" />
                    <div data-id="element-128">
                      <p className="font-semibold" data-id="element-129">Clinical-Grade GHK-Cu</p>
                      <p className="text-gray-700" data-id="element-130">
                        Contains the same concentration used in clinical
                        studies—not the trace amounts you'll find in cheaper
                        alternatives. This is the dose that's been proven to
                        work.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-131">
                    <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-132" />
                    <div data-id="element-133">
                      <p className="font-semibold" data-id="element-134">Bioavailable Delivery</p>
                      <p className="text-gray-700" data-id="element-135">
                        The copper peptide is formulated to actually penetrate
                        your skin's barrier and reach those fibroblasts in the
                        dermis where the real aging happens.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-136">
                    <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-137" />
                    <div data-id="element-138">
                      <p className="font-semibold" data-id="element-139">Dermatologist-Formulated</p>
                      <p className="text-gray-700" data-id="element-140">
                        Created specifically for mature skin dealing with
                        decreased collagen production, not just generic
                        "anti-aging."
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-141">
                    <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-142" />
                    <div data-id="element-143">
                      <p className="font-semibold" data-id="element-144">No Irritating Additives</p>
                      <p className="text-gray-700" data-id="element-145">
                        Free from fragrances, parabens, and phthalates. No
                        unnecessary fillers. Just the actives your skin needs to
                        rebuild itself.
                      </p>
                    </div>
                  </div>
                </div>
                <p className="mb-4" data-id="element-146">
                  <span className="font-semibold" data-id="element-147">How to use it:</span> Apply
                  2-3 drops to clean skin morning and night. Can be used with or
                  without your other serums. Unlike retinol, you don't need to
                  "ease in"—it's gentle enough to use daily from day one.
                </p>
              </div>

              {/* Timeline Section */}
              <div className="mb-10" data-id="element-148">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-149">
                  What to Expect: The Realistic Timeline
                </h2>
                <p className="mb-4" data-id="element-150">
                  This isn't a miracle cream that erases 20 years overnight.
                  It's science. And science takes consistency.
                </p>
                <p className="mb-4" data-id="element-151">But here's what most women report:</p>
                <div className="space-y-4 mb-6" data-id="element-152">
                  <div className="bg-blue-50 p-5 rounded-lg" data-id="element-153">
                    <h3 className="font-bold text-lg mb-2" data-id="element-154">
                      Week 1-2: The Glow Phase
                    </h3>
                    <p data-id="element-155">
                      You'll notice improved hydration and a subtle glow within
                      the first week. Your skin feels smoother, more
                      comfortable, less tight.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-5 rounded-lg" data-id="element-156">
                    <h3 className="font-bold text-lg mb-2" data-id="element-157">
                      Week 4-6: The Texture Phase
                    </h3>
                    <p data-id="element-158">
                      Fine lines begin to soften as your skin's hydration
                      improves. The texture becomes more refined. That "crepey"
                      look starts to diminish.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-5 rounded-lg" data-id="element-159">
                    <h3 className="font-bold text-lg mb-2" data-id="element-160">
                      Week 8-12: The Structure Phase
                    </h3>
                    <p data-id="element-161">
                      This is when the collagen remodeling becomes visible.
                      Deeper lines start to reduce. Skin firmness improves. You
                      might hear: "Wait, are you doing something different? You
                      look rested."
                    </p>
                  </div>
                </div>
                <p className="mb-4" data-id="element-162">
                  The key is consistency. This isn't a quick fix that fades.
                  It's a long-term solution that addresses the root cause of
                  aging skin.
                </p>
              </div>

              {/* FAQ Section */}
              <div className="mb-10" data-id="element-163">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-164">
                  Your Biggest Questions, Answered
                </h2>
                <div className="space-y-6" data-id="element-165">
                  <div data-id="element-166">
                    <h3 className="font-bold text-lg mb-2" data-id="element-167">
                      "I've tried peptides before and nothing happened."
                    </h3>
                    <p className="text-gray-700" data-id="element-168">
                      Most peptide serums contain ineffective concentrations or
                      the wrong peptides entirely. There are dozens of peptides
                      on the market, but GHK-Cu is the only one with 50 years of
                      clinical evidence showing it actually stimulates collagen
                      production and reduces breakdown.
                    </p>
                  </div>
                  <div data-id="element-169">
                    <h3 className="font-bold text-lg mb-2" data-id="element-170">
                      "Will this irritate my sensitive skin like retinol did?"
                    </h3>
                    <p className="text-gray-700" data-id="element-171">
                      GHK-Cu is naturally anti-inflammatory—the opposite of
                      retinol's mechanism. Many women with rosacea and eczema
                      specifically seek out copper peptides because they're so
                      gentle. If your skin couldn't handle retinol, this is your
                      alternative.
                    </p>
                  </div>
                  <div data-id="element-172">
                    <h3 className="font-bold text-lg mb-2" data-id="element-173">
                      "Why haven't I heard of this before?"
                    </h3>
                    <p className="text-gray-700" data-id="element-174">
                      GHK-Cu has been used in medical settings for 50 years, but
                      it's only recently that cosmetic-grade formulations have
                      become available to consumers. Your dermatologist has
                      likely known about it. Now you do too.
                    </p>
                  </div>
                  <div data-id="element-175">
                    <h3 className="font-bold text-lg mb-2" data-id="element-176">
                      "How do I know this will work for me?"
                    </h3>
                    <p className="text-gray-700" data-id="element-177">
                      Every skin is different, but the clinical studies are
                      compelling. Thousands of women have already experienced
                      the difference. Plus, for a limited time, you can try
                      Glisera™ at a significant discount—making it easier to
                      test without the premium price tag.
                    </p>
                  </div>
                </div>
              </div>

              {/* Limited Time Offer Section */}
              <div className="mb-10 bg-gradient-to-r from-rose-50 to-pink-50 p-6 rounded-lg border border-rose-200" data-id="element-178">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-179">
                  Limited Time: Save 40% on Glisera™
                </h2>

                {/* Product Application Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-180">
                  <img src="https://cdn.magicpatterns.com/uploads/o249cu8CK5h4pb78dQrKeN/ChatGPT_Image_17_Δεκ_2025,_11_48_32_μ.μ..png" alt="Woman applying Glisera Copper Renewal Serum with dropper - showing proper application technique for best results" className="w-full h-auto" data-id="element-181" />
                </div>

                <p className="mb-4" data-id="element-182">
                  Normally, clinical-grade copper peptide serums retail for
                  premium prices—and for good reason. The raw materials are
                  expensive. The formulation is sophisticated. The concentration
                  actually works.
                </p>
                <p className="mb-4" data-id="element-183">
                  But for a limited time, readers of this article can save 40%
                  on Glisera™ Copper Renewal Serum.
                </p>
                <p className="mb-4" data-id="element-184">Why?</p>
                <p className="mb-4" data-id="element-185">
                  The team behind Glisera™ believes that effective skincare
                  shouldn't require a luxury budget. They'd rather you
                  experience the results than pay for expensive department store
                  markups and celebrity endorsements.
                </p>
                <p className="mb-4 font-semibold" data-id="element-186">What you're getting:</p>
                <div className="space-y-2 mb-6" data-id="element-187">
                  <div className="flex items-start" data-id="element-188">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-189" />
                    <p data-id="element-190">
                      A 30-day supply of clinical-grade GHK-Cu copper peptide
                      serum
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-191">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-192" />
                    <p data-id="element-193">Formulated by board-certified dermatologists</p>
                  </div>
                  <div className="flex items-start" data-id="element-194">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-195" />
                    <p data-id="element-196">The same concentration used in clinical studies</p>
                  </div>
                  <div className="flex items-start" data-id="element-197">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-198" />
                    <p data-id="element-199">Free shipping directly to your door in {userCity}</p>
                  </div>
                </div>
                <p className="mb-4" data-id="element-200">
                  Fair warning: Due to the quality of raw materials and the time
                  it takes to formulate each batch, Glisera™ occasionally sells
                  out. The 40% discount is currently active, but inventory is
                  limited.
                </p>
                <p className="mb-4" data-id="element-201">
                  Don't spend another dollar on serums that only address half
                  the problem.
                </p>
                <p className="mb-6 font-semibold" data-id="element-202">
                  Try the peptide that's been trusted in medical settings for 50
                  years—now available for home use.
                </p>
                <div className="flex justify-center" data-id="element-203">
                  <CTAButton data-id="element-204" />
                </div>
              </div>

              {/* Final Testimonial */}
              <div className="mb-10" data-id="element-205">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-206">
                  One Last Thing
                </h2>

                {/* Lifestyle/Confidence Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-207">
                  <img src="https://cdn.magicpatterns.com/uploads/uffAG9a5DHd9mmcdNxTGny/ChatGPT_Image_17_Δεκ_2025,_11_14_40_μ.μ..png" alt="Confident woman in her late 40s with radiant, healthy skin smiling outdoors in natural light - showing the confidence that comes from healthy, youthful-looking skin" className="w-full h-auto" data-id="element-208" />
                </div>

                <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-rose-400 mb-6" data-id="element-209">
                  <p className="italic" data-id="element-210">
                    "Three months ago, I was ready to give up on topical
                    skincare entirely," says Rebecca T., 48, from {userCity}.
                    "I'd wasted so much money on serums that did nothing. But
                    Glisera™ was different. I started seeing real changes by
                    week 3. Now at week 12, my skin looks how I remember it
                    looking at 35—and I'm 48. I can't recommend this enough."
                  </p>
                </div>
                <p className="mb-4" data-id="element-211">
                  Your skin has been destroying collagen faster than it builds
                  it for years.
                </p>
                <p className="mb-6 font-semibold text-lg" data-id="element-212">
                  It's time to fix both sides of the equation.
                </p>
                <div className="flex justify-center" data-id="element-213">
                  <a href="https://www.tryglisera.com/products/glisera%E2%84%A2-copper-renewal-serum" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg shadow-md transition-all transform hover:scale-105 w-full md:w-auto md:min-w-[300px] uppercase tracking-wider inline-block text-center" data-id="element-214">
                    YES, I WANT SMOOTHER, FIRMER SKIN →
                  </a>
                </div>
              </div>
            </div>
          </main>

          {/* Right-side CTA */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-215">
            <div className="sticky top-6" data-id="element-216">
              <StickyCTA showNewImage={true} data-id="element-217" />
            </div>
          </aside>
        </div>
      </div>

      {/* Sticky Bottom CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-218">
        <a href="https://www.tryglisera.com/products/glisera%E2%84%A2-copper-renewal-serum" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block" data-id="element-219">
          GET 40% OFF GLISERA™ NOW!
        </a>
      </div>

      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-220">
        <div className="container mx-auto px-4 py-6" data-id="element-221">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-222">
            <div className="flex items-center" data-id="element-223">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-224" />
              <p className="font-bold text-lg" data-id="element-225">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-lg px-4" data-id="element-226">
              Get Glisera™ Copper Renewal Serum at 40% OFF + FREE Shipping for
              a Limited Time!
            </p>
            <a href="https://www.tryglisera.com/products/glisera%E2%84%A2-copper-renewal-serum" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-base whitespace-nowrap inline-block" data-id="element-227">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer Footer */}
      <footer className="w-full bg-gray-100" data-id="element-228">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-229">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-230">
            <p className="mb-2" data-id="element-231">
              DISCLAIMER: This is an advertorial and not an actual news article,
              blog, or consumer protection update. Results may vary. Individual
              results may vary based on skin type, age, and consistent use.
              These statements have not been evaluated by the FDA. This product
              is not intended to diagnose, treat, cure, or prevent any disease.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-232">
              <span data-id="element-233">About Us</span>
              <span data-id="element-234">|</span>
              <span data-id="element-235">Terms of Use</span>
              <span data-id="element-236">|</span>
              <span data-id="element-237">Privacy Policy</span>
              <span data-id="element-238">|</span>
              <span data-id="element-239">Contact</span>
            </div>
            <p className="mb-2" data-id="element-240">
              We are independently owned, and opinions expressed here are our
              own. This website is an independent professional comparison and
              review site supported by referral fees from the sites and products
              featured.
            </p>
            <p data-id="element-241">©2025 Health & Beauty Journal. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};